import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import "./shared.css";
import { zoneWidgets } from "../api";
import { setZoneWidgets, setSelectedZone } from "../redux";
import { ModalComp, Add, CameraComp } from "./";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiCamera, FiX, FiCheck, FiHome, FiPlus } from "react-icons/fi";

const ShortcutCompp = (props) => {
  const { t } = useTranslation();
  const { modal } = props;
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const dashboardDetail = useSelector((state) => state.dashboardDetails);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [showRoom, setShowRoom] = useState(false);
  const [zoneName, setZoneName] = useState("");
  const [openAddModal, setOpenAddModal] = useState(false);
  const toggleAdd = () => setOpenAddModal(!openAddModal);
  const [openCameraModal, setOpenCameraModal] = useState(false);
  const toggleCamera = () => setOpenCameraModal(!openCameraModal);

  const zoneClick = (zone) => {
    setZoneName(zone.zone_caption);
    dispatch(setSelectedZone(zone));
    const data = new FormData();
    data.append("zone", zone.id);
    zoneWidgets(data, token)
      .then((res) => {
        dispatch(setZoneWidgets(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        } else {
          dispatch(setZoneWidgets([]));
        }
      });
    setShowRoom(false);
  };

  return (
    <>
      <ModalComp modal={openAddModal} toggle={toggleAdd} component={<Add />} />
      <ModalComp
        modal={openCameraModal}
        toggle={toggleCamera}
        component={<CameraComp />}
      />
      
      <div className={`shortcut-bottom-bar ${modal}`}>
        <div className="shortcut-bottom-icons">
          
          <i className="circleIcon cursor" onClick={toggleCamera}>
            <FiCamera size={20} />
          </i>
          <div className="selectBox-bottom" onClick={() => setShowRoom(!showRoom)}>
            <i className="icon-house"></i>
            <span>
              {zoneName
                ? zoneName
                : dashboardZones && dashboardZones[0]?.zone_caption}
            </span>
            <i className={`icon-down-open-big ${showRoom ? "rotate" : ""}`}></i>
          </div>
        </div>
      </div>

      {showRoom && (
        <div className="roomSelect-overlay-bottom" onClick={() => setShowRoom(false)}>
          <div className="roomSelect-card-bottom" onClick={(e) => e.stopPropagation()}>
            <div className="roomSelect-header-bottom">
              <div className="roomSelect-header-info-bottom">
                <div className="roomSelect-header-icon-bottom">
                  <FiHome size={22} />
                </div>
                <div>
                  <p className="roomSelect-dashboard-name-bottom">{dashboardDetail.dashboard_caption}</p>
                  <p className="roomSelect-dashboard-count-bottom">
                    {dashboardDetail.zone_allowed_count === 1
                      ? `${dashboardDetail.zone_allowed_count} ${t("اتاق")}`
                      : `${dashboardDetail.zone_allowed_count} ${t("اتاق")}`}
                  </p>
                </div>
              </div>
              <button className="roomSelect-close-bottom" onClick={() => setShowRoom(false)}>
                <FiX size={18} />
              </button>
            </div>
            
            <div className="roomSelect-list-bottom">
              {dashboardZones?.map((zone, index) => (
                <div
                  key={index}
                  className={`roomSelect-item-bottom ${zoneName === zone.zone_caption ? "active" : ""}`}
                  onClick={() => zoneClick(zone)}
                >
                  <div className="roomSelect-item-icon-bottom">
                    <FiHome size={16} />
                  </div>
                  <span className="roomSelect-item-name-bottom">{zone.zone_caption}</span>
                  {zoneName === zone.zone_caption && <FiCheck size={14} />}
                </div>
              ))}
            </div>
            
            <div className="roomSelect-footer-bottom">
              <button className="roomSelect-add-btn-bottom" onClick={toggleAdd}>
                <FiPlus size={16} />
                <span>{t("اتاق جدید")}</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Shortcut = withRouter(ShortcutCompp);

export { Shortcut };